import { UpsertCourt } from "@/components/clubs/upsert-court/UpsertCourt";
import { Button } from "@/components/ui/button";
import { ChevronLeft, Edit, Lock } from "lucide-react";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export const CreateCourt: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const clubId = params.id || location.state?.clubId;
    const court = location.state?.court;
    const isReadOnly = location.state?.isReadOnly || false;

    const handleOnSuccess = () => {
        navigate('/clubs');
    }

    const handleBack = () => {
        navigate(`/clubs/${clubId}/courts${isReadOnly ? '?readonly=true' : ''}`, {
            state: { clubId }
        });
    }

    return (
        <div className="mb-8">
            <div className="mb-6 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <Button 
                        variant="ghost" 
                        onClick={handleBack}
                        className="flex items-center gap-2"
                    >
                        <ChevronLeft size={16} />
                    </Button>
                    {isReadOnly ? (
                        <Lock size={28} className="text-blue-600" />
                    ) : (
                        <Edit size={28} className="text-green-600" />
                    )}
                    <div>
                        <h2 className="text-2xl font-bold">
                            {court 
                                ? (isReadOnly ? 'Ver Cancha' : 'Editar Cancha')
                                : 'Nueva Cancha'
                            }
                        </h2>
                    </div>
                </div>
            </div>
            
            <UpsertCourt 
                clubId={clubId} 
                court={court} 
                onSuccess={handleOnSuccess}
                isReadOnly={isReadOnly}
            />
        </div>
    )
}